import React from "react";
import styles from "./reviewcard.module.css";
import { TiStarOutline } from "react-icons/ti";

const ReviewCard = ({ title, ratingCount }) => {
  // const { theme } = useSelector((state) => state.theme);

  return (
    <div
      className={`${styles.cardContainer}`}
    >
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{title}</span>
        <span className={styles.cardRatingCount}>{ratingCount}</span>
      </div>
      <div className={styles.cardContent}>
        {[...Array(5)].map((_, index) => (
          <div key={index} className={styles.starRow}>
            <span className={styles.stars}>
              {[...Array(5)].map((_, starIndex) => (
                <TiStarOutline key={starIndex} className={styles.star} />
              ))}
            </span>
            <span className={styles.percentage}>0 (0%)</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewCard;
